export type LegacyTimeOfDay = "day" | "evening";
export type TimeOfDayValue = number;

export const DEFAULT_TIME_OF_DAY: TimeOfDayValue = 0;
export const GOLDEN_HOUR_TIME_OF_DAY: TimeOfDayValue = 0.7;
export const NIGHT_TIME_OF_DAY: TimeOfDayValue = 1;

export function clampTimeOfDay(value: number): TimeOfDayValue {
	if (!Number.isFinite(value)) return DEFAULT_TIME_OF_DAY;
	return Math.min(NIGHT_TIME_OF_DAY, Math.max(DEFAULT_TIME_OF_DAY, value));
}

export function normalizeTimeOfDay(value: unknown): TimeOfDayValue {
	if (value === "day") return DEFAULT_TIME_OF_DAY;
	if (value === "evening") return NIGHT_TIME_OF_DAY;
	if (typeof value === "number") return clampTimeOfDay(value);
	if (typeof value === "string") {
		const parsed = Number(value);
		if (Number.isFinite(parsed)) return clampTimeOfDay(parsed);
	}
	return DEFAULT_TIME_OF_DAY;
}

export function isNightTimeOfDay(value: TimeOfDayValue): boolean {
	return normalizeTimeOfDay(value) >= 0.75;
}
